import { createEntity } from '@luna/api';
import type { ProductMetadata } from '@api-client/products';
import { AggregationService } from '@api-client/products';
import { deepClean } from '@luna/utils';

export const productsEntity = createEntity({
    name: '@products/aggregation/products',
    withEntityType: {} as ProductMetadata,
    payloadCreators: {
        queryAll: async ({
            id,
            page,
            size,
        }: Parameters<typeof AggregationService.getPublicProducts>[0] = {}): Promise<
            ProductMetadata[]
        > => {
            const { items = [] } = await AggregationService.getPublicProducts(
                deepClean({ id, page, size }),
            );

            return items;
        },
    },
});
